
module.controller('addSubCtrl', ['$scope', '$state', '$http', 'cacheService', 'Session', 'LimitsService', 'Transform', 'OVERLAY', 'baseURI','$rootScope', function ($scope, $state, $http, cacheService, Session, LimitsService, Transform, OVERLAY, baseURI,$rootScope){
  var addUrl = baseURI + 'card/sub-cards';

  var subCards = [];
  var defaultAlert = 'Sorry, we were unable to add a new card at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
  var fieldValidationAlert = 'Please enter only alphabetic characters (A-Z) for the cardholder name.';
  var lowFundsAlert = 'Oops, looks like you do not have enough funds on your ' + $scope.brand.commonProgramName + ' to create a card. Minimum balance required is $5.00.';

  $scope.alert = {};
  $scope.overlay = OVERLAY['member.home.subaccount/add'];
  $scope.attempted = false;

  $scope.formData = {};

  var onlyPhysical = !$rootScope.hasVirtualSubProgram;
  var onlyVirtual = !$rootScope.hasPhysicalSubProgram;

  $scope.formData.Virtual = onlyVirtual;

  if (onlyPhysical) {
    $scope.cardTypeLabel = 'Physical Card';
  } else if (onlyVirtual) {
    $scope.cardTypeLabel = 'Virtual Card';
  } else {
    $scope.cardTypeLabel = 'Create a Physical Card or a Virtual Card?';
  }

  $scope.formData.atm = Session.getExpense() ? 'off' : 'on';

  $scope.limits = Session.getLimits()['SUB-CARDS'];

  $scope.processForm = function(formData){
    addSub(formData);
  };
  $scope.attemptSubmission = function(formData){
    if(formData.$valid){
      if($scope.limits.count === 0){
        $scope.tooManySubs = true;
      } else {
        $scope.alert.errorShown = false;
        $state.go('member.home.subaccount/add.step2');
      }
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  function addSub(formData){
    $scope.loading = true;
    var newSub = {
      FirstName: formData.FirstName,
      LastName: formData.LastName,
      CorporateName: formData.CorporateName || '',
      Virtual: formData.Virtual ? 'true' : 'false',
      ATMInternationalAccess: (formData.atm === 'on' ? 'true' : 'false')
    };
    $http({
      method: 'POST',
      url: addUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(newSub)
    }).then(function (resp){
      var data = resp.data;

      if(data.Success){
        // Clear the cache for subcards
        cacheService.clear('subcard');

        // Update limits service
        LimitsService.update();

        $scope.alert.successShown = true;
        $scope.alert.successMessage = 'You\'ve created a subcard';

        if (newSub.Virtual === 'true') {
          $scope.title = 'Your card has been created';
        } else {
          $scope.isPhysical = true;
        }

        $state.go('member.home.subaccount/add.step3');
      } else {
        $scope.alert.alertMessage = defaultAlert;
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      if(error.data.ErrorCode === 130) {
        $scope.alert.alertMessage = lowFundsAlert;
        $scope.alert.alertShown = true;
        $scope.loading = false;
      } else if (error.data.ErrorCode === 20) {
        $scope.alert.alertMessage = fieldValidationAlert;
        $scope.alert.alertShown = true;
        $scope.loading = false;
      } else {
        $scope.alert.alertMessage = defaultAlert;
        $scope.alert.alertShown = true;
        $scope.loading = false;
      }
    }).then(function (){
      $scope.loading = false;
    });
  }

  var getSubs = function(){
    var url = baseURI + 'card/sub-cards';
    $http.get(url, {cache: true}).then(function (resp){
      subCards = resp.data.Data || [];
    }).catch(function (error){
      $scope.loading = false;
      console.log('err', error);
    });
  };

  getSubs();
}]);
